<ng-container *transloco="let t">
  <app-nav-tabs [reduceHorizontalSpacing]=true #nav>
    <app-nav-tab [title]="t('league.details.tab.basic.data')" [itemId]="1" [isChecked]="!isLeagueInvalid"
                 [showIndicator]="true">
      <ng-template>
        @if (currentLeague?.visibilityStatus === VisibilityStatus.VISIBLE) {
        <ng-template [ngTemplateOutlet]="visibleWarning"/>
        }
        @if (currentLeague?.visibilityStatus === VisibilityStatus.REQUEST_SENT) {
        <ng-template [ngTemplateOutlet]="publishingWarning"/>
        }
        <app-league-basic-data [currentLeague]="currentLeague" [leagueDetailsComponentType]="componentType"
                               [languages]="languages" [organisers]="organisers" [userRole]="userRole" [disableEditing]="editingDisabled"
                               [sports]="sports" [countries]="countries"
                               (onLeagueChange)="leagueChange($event)"/>
      </ng-template>
    </app-nav-tab>
    <app-nav-tab [title]="t('league.details.tab.events')"
                 [itemId]="2"
                 [isChecked]="isLeagueEventsValid"
                 [showIndicator]="true">
      <ng-template>
        @if (!currentLeague?.id) {
        <ng-template [ngTemplateOutlet]="basicDataWarning"/>
        }
        @else {
          @if (currentLeague?.visibilityStatus === VisibilityStatus.REQUEST_SENT) {
          <ng-template [ngTemplateOutlet]="publishingWarning"/>
          }
          <app-league-events
            [league]="currentLeague"
            [leagueEvents]="leagueEvents"
            [sports]="sports"
            [countries]="countries" [disableEditing]="currentLeague?.visibilityStatus === VisibilityStatus.REQUEST_SENT " [languages]="languages" (onLeagueEventsChange)="leagueEventsChanged($event)"/>
        }
      </ng-template>
    </app-nav-tab>
    <app-nav-tab [title]="t('league.details.tab.scoring.configuration')" [itemId]="3" [isChecked]="isScoringConfigValid"
                 [showIndicator]="true">
      <ng-template>
        @if (!currentLeague?.id) {
        <ng-template [ngTemplateOutlet]="basicDataWarning"/>
        }
        @else {
          @if (currentLeague?.visibilityStatus === VisibilityStatus.VISIBLE) {
            <ng-template [ngTemplateOutlet]="visibleWarning"/>
          }
          @if (currentLeague?.visibilityStatus === VisibilityStatus.REQUEST_SENT) {
            <ng-template [ngTemplateOutlet]="publishingWarning"/>
          }
          <app-league-scoring-configuration [league]="currentLeague"
                                          [scoringMethods]="scoringMethods"
                                          [rankingMethods]="rankingMethods"
                                          [attendanceBonusTypes]="attendanceBonusTypes"
                                          [groupScoringTypes]="groupScoringTypes"
                                          [scoringDefinitions]="scoringDefinitions "
                                          [individualScoringConfigs]="individualScoringConfigurations"
                                          [groupScoringConfigs]="groupScoringConfigurations"
                                          [measurementPrecisionTypes]="measurementPrecisionTypes"
                                          [disableEditing]="editingDisabled"
                                          (scoringConfigurationChange)="onScoringConfigurationChange()"
        />
        }
      </ng-template>
    </app-nav-tab>
    <app-nav-tab [title]="t('league.details.tab.scoring.categorization')" [itemId]="4" [isChecked]="isScoringCategorizationValid"
                 [showIndicator]="true">
      <ng-template>
        @if (!currentLeague?.id) {
          <ng-template [ngTemplateOutlet]="basicDataWarning"/>
        }
        @else {
          @if (currentLeague?.visibilityStatus === VisibilityStatus.VISIBLE) {
          <ng-template [ngTemplateOutlet]="visibleWarning"/>
          }
          @if (currentLeague?.visibilityStatus === VisibilityStatus.REQUEST_SENT) {
          <ng-template [ngTemplateOutlet]="publishingWarning"/>
          }
          <app-league-scoring-categorization [league]="currentLeague" (scoringCategorizationChange)="onScoringCategorizationChange()"
                                           [categorizations]="scoringCategorizations" [disableEditing]="editingDisabled"
                                           [leagueEvents]="leagueEvents"
                                           [individualScoringConfigs]="individualScoringConfigurations"
                                           [groupScoringConfigs]="groupScoringConfigurations"/>

        }
      </ng-template>
    </app-nav-tab>
  </app-nav-tabs>

  <ng-template #publishingWarning>
    <div class="pt-3">
      <ngb-alert [dismissible]="false" class="warning-info mb-4">
        <div class="d-flex align-items-center justify-content-between">
          <div>
            {{ t( isAdministrator ? 'league.details.publishing.warning.admin' : 'league.details.publishing.warning.organiser') }}
          </div>
          @if (isAdministrator) {
          <div class="d-flex">
            <div class="pe-2">
              <app-floating-icon-button iconClass="bi bi-check-lg" (onClick)="openModifyRequestDialog(true)"></app-floating-icon-button>
            </div>
            <app-floating-icon-button iconClass="bi  bi-x-lg bold" (onClick)="openModifyRequestDialog(false)"></app-floating-icon-button>
            </div>
          }
        </div>
      </ngb-alert>
    </div>
  </ng-template>

  <ng-template #visibleWarning>
    <div class="pt-3">
      <ngb-alert [dismissible]="false" class="warning-info mb-4">
        <div class="d-flex align-items-center justify-content-between">
          <div>
            {{ t("league.details.visible.warning.1") }} <strong>
            <a (click)="onEnableEditingClick()">{{ t("league.details.visible.warning.2") }}</a></strong>
          </div>
          <div>
            <app-floating-icon-button iconClass="fas fa-pencil-alt" (onClick)="onEnableEditingClick()"></app-floating-icon-button>
          </div>
        </div>
      </ngb-alert>
    </div>
  </ng-template>

  <ng-template #basicDataWarning>
    <div class="pt-3">
      <ngb-alert [dismissible]="false" class="warning-info mb-4">
        <div class="d-flex align-items-center justify-content-between">
          <div>
            {{ t("league.details.basic.data.warning.1") }} <strong>
            <a (click)="navigateToLeagueBasicInfo()">{{ t("league.details.basic.data.warning.2") }}</a></strong>
          </div>
        </div>
      </ngb-alert>
    </div>
  </ng-template>

</ng-container>
